import classNames from 'classnames'
import React from 'react'
import { getIcon } from '../icons/utils'
import styles from './CloseButton.module.css'

type CloseButtonProps = React.HTMLProps<HTMLButtonElement> & {
  dataTestId?: string
}

export const CloseButton: React.FC<CloseButtonProps> = ({ className, dataTestId, ...props }) => {
  return (
    <button data-testid={dataTestId} className={classNames(styles.closeButton, className)} {...props} type='button'>
      {getIcon('close')}
    </button>
  )
}
